import { ProgressBar } from "./ProgressBar";
export class WelcomeScreen {
    constructor(app) {
        this.app = app;
        // This is step 0 of the 6-step core process, so the bar is empty.
        this.progressBar = new ProgressBar(6, 0);
    }
    render() {
        return `
            <div class="card">
                ${this.progressBar.render()}
                <h2>Let's Build Your High-Fidelity Data Asset</h2>
                <p>This guided 6-step process is the foundation. By understanding your core motivations, values, and personality, the system can become a true co-pilot for your productivity.</p>
                <p>This is the first step in creating a <strong>Shared Reality</strong> between you and the system.</p>
                <div class="button-container">
                    <button id="begin-onboarding" class="button-primary">Begin</button>
                </div>
            </div>
        `;
    }
    attachEventListeners() {
        var _a;
        (_a = document.getElementById('begin-onboarding')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
            this.app.nextStep();
        });
    }
}
